import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from '../data/translations';
import type { Language } from '../types/language';
interface LanguageContextValue {
  language: Language;
  setLanguage: (language: Language) => void;
  t: (typeof translations)[Language];
}
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>(() => {
    if (typeof window === 'undefined') return 'en';
    const saved = window.localStorage.getItem('leonardo-language');
    if (saved === 'en' || saved === 'es') return saved;
    return window.navigator.language.toLowerCase().startsWith('es') ? 'es' : 'en';
  });
  useEffect(() => {
    document.documentElement.lang = language;
    window.localStorage.setItem('leonardo-language', language);
  }, [language]);
  const value = useMemo(() => ({
    language,
    setLanguage: setLanguageState,
    t: translations[language]
  }), [language]);
  return <LanguageContext.Provider value={value} data-id="element-198" data-mp="3cy0o0tkcxyzk">{children}</LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used inside LanguageProvider');
  return context;
}